<template>
  <div id="forgetpassmain">
    <span class="titleline" @click="checkLogin()">返回登录</span>
    <label class="loginLable" style="margin-bottom: 5%;margin-top: 5%;">密码重置</label>
    <el-form ref="forgotForm" :model="forgotForm" :rules="forgotFormRules">
      <el-form-item prop="username">
        <el-input ref="input" prefix-icon="iconfont icon-login-username" v-model="forgotForm.username" placeholder="请输入手机号"
          style="width: 65%;">
        </el-input>
        <button class="yzmbtn" type="button" @click="getMessageCode()" v-text="messageCodeText" :disabled="mobileBtnDisabled"></button>
      </el-form-item>

      <el-form-item prop="yanzhengma">
        <el-input prefix-icon="iconfont icon-login-password" class="iconStyle" v-model="forgotForm.yanzhengma"
          placeholder="请输入验证码">
        </el-input>
      </el-form-item>

      <el-form-item prop="password">
        <el-input prefix-icon="iconfont icon-login-password" class="iconStyle" v-model="forgotForm.password"
          placeholder="请输入密码" type="password">
        </el-input>
      </el-form-item>

      <el-form-item prop="password1">
        <el-input prefix-icon="iconfont icon-login-password" class="iconStyle" v-model="forgotForm.password1"
          placeholder="确认密码" type="password">
        </el-input>
      </el-form-item>
      <div class="div1">
        <div>
          <span @click="checkForgotUsername()" class="span1">
            忘记用户名</span>
        </div>
      </div>
      <div class="login-btn" style="">
        <el-button size="medium" @click="updatePassword('forgotForm')" type="primary">重置密码</el-button>
      </div>

    </el-form>
  </div>
</template>

<script>
  import {Encrypt,Decrypt} from '@/common/js/secret.js'
  export default {
    name: 'forgetpassmain',
    data() {
      var validatePhone = (rule, value, callback) => {
        //   
        if (value == "" || value == null) {
          return callback(new Error('请输入手机号'));
        } else if (!/^1[345789]\d{9}$/.test(value)) {
          return callback(new Error('请输入正确手机号'));
        } else {
          callback();
        }
      };

      // var validatePass1 = (rule, value, callback) => {
      //   //   
      //   var regu = "^[0-9a-zA-Z]{6,16}$";
      //   var re = new RegExp(regu);
      //   if (value == "" || value == null) {
      //     return callback(new Error('请输入密码'));
      //   } else if (re.test(value)) {
      //     callback();
      //   } else {
      //     return callback(new Error('6-16位数字和字母的组合'));
      //   }
      // };

      var validatePass2 = (rule, value, callback) => {
        //  
        if (value == "" || value == null) {
          return callback(new Error('请再次输入密码'));
        } else if (value != "" && value != null && value == this.forgotForm.password) {
          callback();
        } else {
          return callback(new Error('两次密码输入不一致'));
        }
      };
      return {
        forgotForm: {
          username: "",
          password: "",
          password1: "",
          yanzhengma: ""
        },
        forgotFormRules: {
          username: [{
            validator: validatePhone,
            trigger: "blur"
          }],
          yanzhengma: [{
              required: true,
              message: "请输入验证码",
              trigger: "blur"
            },
            {
              min: 6,
              max: 6,
              message: "验证码为6位"
            }
          ],
          password: [{
              required: true,
              message: "请输入密码",
              trigger: "blur"
            },
            {
              min: 8,
              message: "密码最少8位"
            },
            {
              pattern: /(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}/,
              message: "密码必须包含数字、字母、特殊字符至少三种",
              trigger: "blur"
            }
          ],
          password1: [{
            validator: validatePass2,
            trigger: "blur"
          }],
        },
        messageCodeText: "获取验证码",
        mobileBtnDisabled: false,
        time: 60,

      }
    },
    created() {},
    methods: {
      init: function() {
        this.$refs["forgotForm"].resetFields()
      },
      checkLogin: function() {
        this.$parent.isLogin = true;
        this.$parent.isRegister = false;
        this.$parent.isForgot = false;
        this.$parent.isForgotUsername = false;
        this.$parent.$refs.loginmain.init();
      },
      checkForgotUsername: function() {
        this.$parent.isLogin = false;
        this.$parent.isRegister = false;
        this.$parent.isForgot = false;
        this.$parent.isForgotUsername = true;
        this.$parent.$refs.forgetusernamemain.init();
      },
      mobileCheck() {
        var name = "";
        if (this.forgotForm.username != null && this.forgotForm.username != "") {
          name = this.forgotForm.username;
        }
        if (!/^1[345789]\d{9}$/.test(name)) {
          //用户名不正确，显示红字提醒
          this.usernameAlertFlag = true;
          return false;
        } else {
          this.usernameAlertFlag = false;
          return true;
        }
      },
      //修改密码
      updatePassword: function(formName) {
        this.$refs[formName].validate(valid => {
          let vm = this;
          if (valid) {
            var params = {
              username: vm.forgotForm.username,
              password: vm.forgotForm.password,
              salt: vm.forgotForm.yanzhengma
            };
            vm.$axios.post("/signin/updateByVO", params).then(function(res) {
                vm.$alert(res.data.msg, '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                    if(res.data.code == "00000000"){
                      this.$parent.checkLogin();
                    }
                  }
                });

              }.bind(vm),function(error) {
                console.log(error);
              }
            );
          }
        });
      },
      //获取手机验证码
      getMessageCode: function() {
        this.$nextTick(() => { //自动获取焦点 element组件autofocus失效
          this.$refs.input.$refs.input.focus()
        })
        if (this.forgotForm.username == "" || this.forgotForm.username == null) {
          this.$nextTick(() => { //自动获取焦点 element组件autofocus失效
            this.$refs.input.$refs.input.blur()
          })
        } else {
          let vm = this;
          vm.messageCode = "";
          if (vm.mobileCheck()) {
            vm.messageCodeText = "发送中...";
            vm.mobileBtnDisabled = true;
            vm.$axios.get("/signin/getUsernameNum/" + vm.forgotForm.username + "/static").then(function(res) {
                if (res.data.result == 0) {
                  this.$alert('用户名不存在', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                      vm.messageCodeText = "获取验证码";
                      vm.mobileBtnDisabled = false;
                    }
                  });

                } else {
                  vm.$axios.get("/signin/sendMessage?phone=" + vm.forgotForm.username).then(function(res) {
                      if(res.data.code == "00000000"){
                        var count = vm.time;
                        vm.timer = setInterval(() => {
                          if (count == 0) {
                            clearInterval(vm.timer);
                            vm.timer = null;
                            vm.messageCodeText = "获取验证码";
                            vm.mobileBtnDisabled = false;
                          } else {
                            vm.messageCodeText = count + "秒后获取";
                            count--;
                            vm.mobileBtnDisabled = true;
                          }
                        }, 1000);
                      }else{
                        this.$alert(res.data.msg, '提示', {
                          confirmButtonText: '确定',
                          callback: action => {
                            vm.messageCodeText = "获取验证码";
                            vm.mobileBtnDisabled = false;
                          }
                        });
                      }
                    }.bind(vm),function(error) {
                      console.log(error);
                    }
                  );
                }
              }.bind(vm),function(error) {
                console.log(error);
              }
            );
          }
        }
      },
    }
  };
</script>
<style lang="scss">
  #forgetpassmain {
    .div1 {
      display: block;
      position: absolute;
      right: 0;
      bottom: 3rem;
      text-align: right;
    }

    .span1 {
      font-size: 1rem;
      color: #409eff;
      display: inline-block;
      width: auto;
      height: auto;
    }

  }
</style>



// WEBPACK FOOTER //
// src/views/login/ForgetPassword.vue